import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-registration-presenter',
    templateUrl: './registration-presenter.component.html',
    styleUrls: ['./registration-presenter.component.scss'],
    standalone: false
})
export class RegistrationPresenterComponent {
    public RegistrationForm: UntypedFormGroup;
    @Output() SaveRegistration: EventEmitter<{
        ProductCode: string;
        CustomerId: string;
        EIN: string;
    }> = new EventEmitter();
    constructor(private log: LoggingService) {
        this.RegistrationForm = new UntypedFormGroup({
            ProductCode: new UntypedFormControl('', [Validators.required]),
            CustomerId: new UntypedFormControl('', [Validators.required]),
            EIN: new UntypedFormControl('', [Validators.required])
        });
    }

    onSubmit($event: { ProductCode: string; CustomerId: string; EIN: string }) {
        this.log.verbose({ type: 'RegistrationPresenterComponent', $event });
        this.SaveRegistration.emit($event);
    }
}
